@if (races.length > 0 || !filterOutAll) {
    <div class="next-races" [class.single-race]="races.length === 1">
        <div class="filter-background">
            <div class="next-race-filter-parent">
                <div class="title">{{ sitecore.horseRacing.nextThreeRaces.Title }}</div>
                <div class="next-race-filter-float">
                    <ul class="next-races-pills">
                        <li>
                            <button ds-pill size="small" [selected]="filterOutAll" (click)="filterOut(true)">
                                {{ sitecore.horseRacing.nextThreeRaces.All }}
                            </button>
                        </li>
                        <li>
                            <button ds-pill size="small" [selected]="!filterOutAll" (click)="filterOut(false)">
                                {{ sitecore.horseRacing.nextThreeRaces.UKIreland }}
                            </button>
                        </li>
                    </ul>
                </div>
            </div>
            @if (races.length > 0) {
                <div class="scroll-container">
                    <div class="next-races-container" [class.fixed-width]="isFixedWidth$ | async">
                        <ms-scroll-adapter size="medium" [scrollSize]="scrollSize" (select)="track($event)">
                            @for (race of races; track trackRace(i, race); let i = $index) {
                                <div class="race-preview">
                                    <ms-next-races-card-preview [race]="race" [trackingPosition]="i" />
                                </div>
                            }
                        </ms-scroll-adapter>
                    </div>
                </div>
            }
            @if (races.length === 0 && !filterOutAll) {
                <div class="no-uk-ireland-races-top">
                    <div class="no-uk-ireland-races">
                        <span><i class="theme-info-i"></i></span>
                        <span class="no-uk-ireland-races-info"> {{ sitecore.horseRacing.nextThreeRaces.NoRacesForUKIreland }}</span>
                    </div>
                </div>
            }
        </div>
    </div>
}
